/** Event */
export default {
  create: '創建中',
  createProgramme: 'AI 創建方案',
  aiProgramme: 'AI 方案',
  name: '活動名稱',
  placeholder: '請輸入活動名稱',
  total: '總報名人數',
  likes: '總點讚數',
  income: '總報名收入',
  tips: {
    total: '報名人數不含取消報名',
    income: '收入不含退款、獎勵和商品銷售'
  },
  table: {
    name: '活動名稱',
    status: '活動狀態',
    total: '總報名人數',
    today: '今日報名人數',
    last_week: '上週報名人數',
    create: '創建時間',
    update: '更新時間',
    start: '開始時間',
    end: '結束時間',
    operate: '操作',
    oper: {
      data: '報名數據',
      config: '內容配置',
      progress: '進度配置',
      display: '活動展示',
      screen: '數據大屏',
      share: '活動分享',
      more: '更多功能',
      mores: {
        setting: '顯示設置',
        ad: '廣告設置',
        live: '圖片直播',
        video: '視頻集錦',
        qrcode: '簽到二維碼',
        gift: '禮品獎勵'
      }
    },
    total_number: '共 {total} 項'
  },
  create_form: {
    placeholder: '請輸入',
    status: {
      '是否确认立刻发布活动?': '是否確認立即發布活動？'
    },
    content: {
      title: '活動內容',
      name: {
        label: '活動名稱',
        hover: '本次活動的名稱，例如：首屆兒童繪畫展'
      },
      cycle: {
        label: '活動週期',
        hover: '整個活動時間，從開始到結束：例如：2024.01.20 ~ 2024.05.20；如未確定，請預估一個時間段'
      },
      stage: {
        title: '活動階段',
        desc: '目前只能創建一個階段。如需添加更多，請先完成初始設置，然後在活動列表中使用"進階配置"。',
        name: {
          title: '階段名稱',
          hover: '活動階段的名稱。目前只能建立一個階段；例如：初賽或複賽或海選或決賽'
        },
        start: {
          title: '報名時間',
          hover: '本階段的報名開始時間和結束時間，請精確到分秒。注意：報名時間外不允許報名；如未確定，可稍後填寫'
        },
        hold: {
          title: '舉辦時間',
          hover: '本階段的開始時間和結束時間，請精確到分秒，例如：線下展覽時間段或頒獎典禮時間段；如未確定，可稍後填寫'
        }
      },
      poster: {
        title: '活動海報',
        upload: '點擊上傳',
        tips: {
          _1: '提示：支持 .jpg、.png 圖片格式；圖片容量最大不能超過 5MB；圖片尺寸比例盡量保持 1:1，最小尺寸為 860px*860px',
          _2: '圖片將顯示在報名者頁面頂部，點擊查看圖例'
        }
      },
      detail: {
        desc: '對報名者可見，點擊查看圖例',
        placeholder: '請輸入',
        title: {
          _1: '活動介紹',
          _2: '報名規則',
          _3: '組織機構'
        }
      }
    },
    group: {
      title: '組別信息',
      desc: '目前只能建立一個組別活動。有多個不同組別活動，請先完成活動的初始創建，然後在活動列表中點擊該活動的"活動配置-分賽配置"進行配置。活動系統支持不同組別活動可以設置不同的報名費用、報名表單、基礎評選、報名表單等設置',
      category: {
        title: '活動類別',
        hover: '例如：藝術類；舞蹈類；',
        add: '添加類別',
        name: '類別名稱'
      },
      group: {
        title: '活動組別',
        hover: '例如：青年組；成人組；',
        add: '添加組別',
        name: '組別名稱'
      },
      form: {
        title: '報名表單',
        hover: '報名者需要填寫的信息內容；不同類別或組別可以使用不同的報名表單',
        create: '創建活動報名信息'
      },
      charge: {
        title: '報名費用',
        hover: '不同類別或組別可以設置不同的費用'
      },
      config: {
        title: '詳細配置設置：',
        hover: '不同類別或組別可以設置不同的評選規則、評選標準、評選方式、評選數量、評選結果公佈時間等',
        repeat: {
          title: '同一組別重複報名：',
          hover: '組別活動是否允許用戶使用相同信息多次報名',
          default: '關閉'
        },
        pass: {
          title: '報名審核通過：',
          hover: '用戶提交報名後，系統是否默認審核判斷報名是否有效/無效',
          default: '自動通過',
          prepay: '先審核後付款',
          postpay: '先付款後審核'
        },
        show: {
          title: '報名中心顯示：',
          hover: '個人：填寫一個人的信息時報名；"團隊"：由多個人的信息組成的報名，共享一個作品',
          default: '顯示'
        },
        form: {
          title: '組別報名表單：',
          hover: '個人：填寫一個人的信息時報名；"團隊"：由多個人的信息組成的報名，共享一個作品',
          default: '個人',
          team: '團隊',
          min: '最小團隊人數：',
          max: '最大團隊人數：'
        },
        base: {
          title: '基礎評選功能：',
          hover: '是否啟用基礎評選功能；例如：啟用或關閉',
          default: '關閉'
        },
        commission: {
          title: '合作夥伴佣金：',
          hover: '作為主辦方的下級渠道，合作夥伴設置報名費用的佣金比例',
          default: '關閉'
        },
        inherit: {
          title: '評選號碼繼承：',
          hover: '在主菜單的進階評選管理中，可以設置報名作品的評選號碼，晉級時號碼可以繼承到下一輪',
          default: '關閉'
        }
      }
    },
    session: {
      title: '場次信息',
      desc: '提示：當前場次創建僅關聯上一步創建的組別活動。多個組別活動有場次安排。請先完成活動的初始創建，進入活動管理，點擊"活動配置-分賽配置-場次配置"進行配置。單個組別可以創建多個場次，不同組別也可以創建不同的場次。',
      name: '組別活動',
      number: {
        title: '報名人數',
        hover: '報名人數是針對單個場次設置的。如果有多個場次，每個場次的參與人數需要分別設置',
        config: '設置',
        default: '不限'
      },
      arrange: {
        title: '場次安排',
        hover: '如果相關場次安排還未確定，可以關閉；如果已經有場次安排，可以開啟進行設置，支持線上線下',
        default: '關閉'
      },
      form: '場次形式：',
      online: '線上地址',
      offline: '地區選擇',
      address: '詳細地址',
      time: '場次時間'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/langs/zh_tw/activity.js